import { render, staticRenderFns } from "./AssignedBreakList.vue?vue&type=template&id=5a71578b&scoped=true"
import script from "./AssignedBreakList.vue?vue&type=script&lang=js"
export * from "./AssignedBreakList.vue?vue&type=script&lang=js"
import style0 from "./AssignedBreakList.vue?vue&type=style&index=0&id=5a71578b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a71578b",
  null
  
)

export default component.exports